import {
  Component,
  EventEmitter,
  Inject,
  Input,
  Optional,
  Output,
} from '@angular/core';
import {
  DIALOG_DATA,
  getFormattedDate,
  getFormattedDateTime,
} from '../../../../global.variable';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';

@Component({
  selector: 'gtapp-datetime-picker',
  templateUrl: './datetime-picker.component.html',
  styleUrl: './datetime-picker.component.scss',
  standalone: false,
})
export class DatetimePickerComponent {
  @Input() showDateOnly: boolean = false;
  @Input() dateRange: any;

  @Output() onChangeDateTime = new EventEmitter();

  errorMessage: any;
  startDateTime: any;
  endDateTime: any;
  timeSelectValues: any = [
    { key: 0, value: '00:00' },
    { key: 6, value: '06:00' },
    { key: 18, value: '18:00' },
  ];
  dateSelectValues: any = [
    { key: 0, value: 'Last 12 Hours' },
    { key: 1, value: 'Last 24 Hours' },
    { key: 3, value: 'Last 3 Days' },
    { key: 7, value: 'Last 7 Days' },
    { key: 30, value: 'Last 30 Days' },
  ];

  dialogBox: boolean = false;

  constructor(
    @Optional() protected dialogueRef: DialogRef,
    @Optional() @Inject(DIALOG_DATA) public dialogData: any,
  ) {}

  ngOnInit(): void {
    if (this.dialogData) {
      this.showDateOnly = this.dialogData?.showDateOnly;
      this.dateRange = this.dialogData?.dateRange;
      this.dialogBox = true;
    }

    if (this.dateRange) {
      if (this.showDateOnly) {
        this.startDateTime = getFormattedDate(this.dateRange?.start);
        // https://app.shortcut.com/sendem/story/13427/issues-with-job-search
        this.endDateTime = getFormattedDateTime(this.dateRange?.end);
        // https://app.shortcut.com/sendem/story/10650/datetime-picker-default-settings-on-load
        // this.endDateTime = getFormattedDate();
        this.dateSelectValues = [
          { key: 3, value: 'Last 3 Days' },
          { key: 7, value: 'Last 7 Days' },
          { key: 30, value: 'Last 30 Days' },
        ];
      } else {
        this.startDateTime = getFormattedDateTime(this.dateRange?.start);
        // https://app.shortcut.com/sendem/story/13427/issues-with-job-search
        this.endDateTime = getFormattedDateTime(this.dateRange?.end);
        // https://app.shortcut.com/sendem/story/10650/datetime-picker-default-settings-on-load
        // this.endDateTime = getFormattedDateTime();
      }
    }
  }
  setTime(date: Date, time: string) {
    const [hours, minutes] = time?.split(':');
    date.setHours(parseInt(hours), parseInt(minutes), 0, 0);
    return date;
  }
  saveDateRange() {
    this.dialogueRef.close({
      start: new Date(this.startDateTime),
      end: new Date(this.endDateTime),
    });
  }
  onDismiss() {
    this.dialogueRef.close('close');
  }
  updateTime(timeObj: any) {
    //https://app.shortcut.com/sendem/story/9830/add-time-of-day-presets-to-datetime-picker

    const startDateTime = this.setTime(
      new Date(this.startDateTime),
      timeObj?.value,
    );
    this.startDateTime = getFormattedDateTime(startDateTime);

    const endDateTime = this.setTime(
      new Date(this.endDateTime),
      timeObj?.value,
    );
    this.endDateTime = getFormattedDateTime(endDateTime);

    this.emitDateTime();
  }
  updateDate(dateKey: number) {
    const currentEndDateTime = this.endDateTime
      ? new Date(this.endDateTime)
      : new Date();
    const newEndDateTime = new Date();
    newEndDateTime.setHours(
      currentEndDateTime.getHours(),
      currentEndDateTime.getMinutes(),
      0,
      0,
    );
    this.endDateTime = this.showDateOnly
      ? getFormattedDate(newEndDateTime)
      : getFormattedDateTime(newEndDateTime);
    const startDateTime = new Date(newEndDateTime);
    if (dateKey == 0) {
      startDateTime.setHours(startDateTime.getHours() - 12);
    } else {
      startDateTime.setDate(startDateTime.getDate() - dateKey);
    }

    this.startDateTime = this.showDateOnly
      ? getFormattedDate(startDateTime)
      : getFormattedDateTime(startDateTime);

    this.emitDateTime();
  }
  emitDateTime() {
    this.onChangeDateTime.emit({
      start: new Date(this.startDateTime),
      end: new Date(this.endDateTime),
    });
  }
}
